/**
 * Route for `lead-ping-tree-ping-post-productized-module`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LeadPingTreePingPostProductizedModulePage } from "../features/lead-ping-tree-ping-post-productized-module/LeadPingTreePingPostProductizedModulePage";

export const leadPingTreePingPostProductizedModuleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/lead-ping-tree-ping-post-productized-module",
	component: LeadPingTreePingPostProductizedModulePage,
});

export default leadPingTreePingPostProductizedModuleRoute;
